import { User } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../config';

export async function createUserProfile(user: User, additionalData?: { name?: string }): Promise<void> {
  if (!user) throw new Error('No user provided');

  const userRef = doc(db, 'users', user.uid);
  const userData = {
    email: user.email,
    displayName: user.displayName || additionalData?.name || 'Anonymous',
    photoURL: user.photoURL,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    subscription: 'free',
    settings: {
      notifications: true,
      theme: 'light'
    }
  };

  await setDoc(userRef, userData, { merge: true });
}